export const DataReducer = (state, data) => {
    // console.log(state===data)
    return data
}